import { navigateTo, YesNoToBoolean } from "../../helper";
import queryString from "query-string";
import RouteNames from "../../routes/type";
import { ClaimState } from "./types";

export const formatPhoneNumber = (input: string): string => {
  const numericInput = input.replace(/[^0-9]/g, "");
  if (!numericInput || numericInput?.length !== 10) {
    return null;
  }
  const areaCode = numericInput.slice(0, 3);
  const firstPart = numericInput.slice(3, 6);
  const secondPart = numericInput.slice(6);
  return `(${areaCode}) ${firstPart}-${secondPart}`;
};

export const nextStepRedirect = (extarProps = {}, step = null) => {
  const parsed = queryString.parse(window.location.search);
  step ||= parseInt(parsed.step.toString()) + 1;
  window.scrollTo(0, 0);
  navigateTo(
    `/${RouteNames.CREATE_CLAIM}?${queryString.stringify({
      ...parsed,
      ...extarProps,
      step,
    })}`
  );
};

export const mapApiClaimData = (state: ClaimState) => {
  const customerInfo = state.customerInfo;
  const purchaseInfo = state.purchaseInfo;
  const damageInfo = state.damageInfo;
  const documents = state.documents;

  return {
    first_name: customerInfo.first_name || "",
    last_name: customerInfo.last_name || "",
    Email: customerInfo.email || "",
    phone_number: customerInfo.number || "",
    address_1: customerInfo.address1 || "",
    address_2: customerInfo.address2 || "",
    city: customerInfo.city || "",
    state: customerInfo.state || "",
    zip: customerInfo.zip || "",
    allow_sms: !!customerInfo.allowSMS,
    //
    store_of_purchase: purchaseInfo.store_purchase || "",
    retailer_phone: purchaseInfo.retailer_phone || "",
    retailer_address_1: purchaseInfo.address1 || "",
    retailer_address_2: purchaseInfo.address2 || "",
    retailer_city: purchaseInfo.city || "",
    retailer_state: purchaseInfo.state || "",
    retailer_zip: purchaseInfo.zip || "",
    purchase_date: purchaseInfo.purchase_date || "",
    invoice_image: purchaseInfo.invoice_image,
    //
    date_of_incident: damageInfo.date_incident || "",
    protector_encasement_type: damageInfo.product_type || "",
    protector_encasement_size: damageInfo.product_size || "",
    mattress_stained_damaged: YesNoToBoolean(
      damageInfo.mattress_stained_damaged
    ),
    protector_encasement_stained_damaged: YesNoToBoolean(
      damageInfo.protector_damage
    ),
    type_of_stain_damage: damageInfo.type_of_stain_damage || "",
    type_of_stain_damage_protector: damageInfo.damage_Protector_type || "",
    damage_notes: damageInfo.damageNotes || "",
    estimated_mattress_retail_value: damageInfo.estimated_retail_value || "",
    did_you_clean_the_protector_encasement: YesNoToBoolean(
      damageInfo.did_clean_product
    ),
    encasement_on_your_bed_at_the_time_of_the_incident: YesNoToBoolean(
      damageInfo.protector_on_bed
    ),
    protector_damage_images:
      documents.protector_damage_images.join("\n\n") || "",
    mattress_damage_images: documents.mattress_damage_images.join("\n\n") || "",
    protectall_tag_image: documents.protectall_tag_image || "",
  };
};

export const makeHTMLContentForTicket = (data: ClaimState, claimName) => {
  const labels = {
    first_name: "First Name",
    last_name: "Last Name",
    email: "Email",
    phone_number: "Phone Number",
    address_1: "Address 1",
    address_2: "Address 2",
    city: "City",
    state: "State",
    zip: "Zip Code",
    store_purchase: "Store of Purchase",
    retailer_phone: "Retailer Phone",
    retailer_address_1: "Retailer Address 1",
    retailer_address_2: "Retailer Address 2",
    retailer_city: "Retailer City",
    retailer_state: "Retailer State",
    retailer_zip: "Retailer Zip",
    purchase_date: "Purchase Date",
    invoice_image: "Invoice Image",
    date_of_incident: "Date of Incident",
    product_size: "Product Size",
    product_type: "Product Type",
    mattress_stained_damaged: "Mattress Stained/Damaged",
    type_of_stain_damage: "Type of Stain/Damage",
    protector_damage: "Protector/Encasement Stained/Damaged",
    damage_Protector_type: "Type of Stain/Damage (Protector)",
    estimated_retail_value: "Estimated Mattress Retail Value",
    did_clean_product: "Did You Clean the Protector/Encasement?",
    protector_on_bed: "Encasement on Bed at Time of Incident?",
    damageNotes: "Damage Notes",
    protector_damage_images: "Protector Damage Images",
    mattress_damage_images: "Mattress Damage Images",
    protectall_tag_image: "ProtectAll Tag Image",
  };

  const getValue = (value) => {
    value ||= "";
    value = value.toString();
    return value.startsWith("https://")
      ? value.toLowerCase().endsWith(".pdf")
        ? `<a href="${value}"><img src="https://upload.wikimedia.org/wikipedia/commons/8/87/PDF_file_icon.svg" style="width: 64px; height: 64px; border-radius: 4px; object-fit: contain;margin-right:8px;"></a>`
        : `<a href="${value}"><img src="${value}" style="width: 64px; height: 64px; border-radius: 4px; object-fit: cover;margin-right:8px;"></a>`
      : value || false;
  };

  const renderRow = (key, value) => {
    const fomrattedValue = Array.isArray(value)
      ? value.length > 0
        ? value.map(getValue).join("")
        : false
      : getValue(value);

    if (fomrattedValue)
      return `<tr><td style="font-weight: 500; padding: 4px; width:300px;"><strong>${
        labels[key] || key
      }</strong></td><td style="padding:4px;">${fomrattedValue}</td></tr>`;
  };

  const renderSection = (title, content) =>
    `<div style="background: rgba(243, 248, 254, 0.8); padding: 4px 8px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 10px;">
      <p style="font-weight: bold; font-size: 18px; color: black; margin-bottom: 10px;">${title}</p>
      <table style="width: 100%; border-collapse: separate; border-spacing: 0 10px; font-size: 14px; color: black;">
        ${content}
      </table>
    </div>`;

  const customerDetails = [
    "first_name",
    "last_name",
    "email",
    "phone_number",
    "address_1",
    "address_2",
    "city",
    "state",
    "zip",
  ]
    .map((key) => renderRow(key, data.customerInfo[key]))
    .join("");

  const purchaseDetails = [
    ["store_purchase"],
    ["retailer_phone"],
    ["address1", "retailer_address_1"],
    ["address2", "retailer_address_2"],
    ["city", "retailer_city"],
    ["state", "retailer_state"],
    ["zip", "retailer_zip"],
    ["purchase_date"],
    ["invoice_image"],
  ]
    .map((key) => renderRow(key[1] || key[0], data.purchaseInfo[key[0]]))
    .join("");

  const damageDetails = [
    "date_of_incident",
    "product_size",
    "product_type",
    "mattress_stained_damaged",
    "type_of_stain_damage",
    "protector_damage",
    "damage_Protector_type",
    "estimated_retail_value",
    "did_clean_product",
    "protector_on_bed",
    "damageNotes",
    "protector_damage_images",
    "mattress_damage_images",
    "protectall_tag_image",
  ]
    .map((key) =>
      renderRow(key, data?.damageInfo?.[key] || data?.documents?.[key])
    )
    .join("");

  return `<div style="font-family: Arial, sans-serif; background-color: #fff;">
    <div style="max-width: 600px; margin: auto;">
    <div style="background: rgba(243, 248, 254, 0.8); padding: 12px; border: 1px solid #ccc; border-radius: 8px; margin-bottom: 5px;">
      <p style="font-weight: bold; font-size: 24px; color: black;text-align:center;margin:0px">${claimName}</p>
    </div>
      ${renderSection("Customer Information", customerDetails)}
      ${renderSection("Purchase Information", purchaseDetails)}
      ${renderSection("Damage Details", damageDetails)}
    </div>
  </div>`;
};
